import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1)
const _hoisted_4 = { class: "modal-content card is-rounded p-4" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "modal-content card is-rounded p-4 has-text-centered" }
const _hoisted_7 = { class: "subtitle" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = { key: 4 }
const _hoisted_23 = { key: 5 }
const _hoisted_24 = { key: 6 }
const _hoisted_25 = { class: "field mb-0" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  class: "label mt-4",
  for: "override"
}
const _hoisted_28 = {
  key: 0,
  class: "field"
}
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  class: "label has-text-weight-normal",
  for: "overrideLarges"
}
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = {
  key: 7,
  class: "mt-4"
}
const _hoisted_35 = { class: "subtitle" }
const _hoisted_36 = { class: "content" }
const _hoisted_37 = {
  key: 0,
  class: "progress is-large is-primary"
}
const _hoisted_38 = ["value"]
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { class: "box mt-4 columns" }
const _hoisted_41 = { class: "column" }
const _hoisted_42 = { class: "has-text-weight-bold" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = { class: "has-text-weight-bold" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = {
  key: 0,
  class: "has-text-weight-bold"
}
const _hoisted_47 = { class: "column" }
const _hoisted_48 = { class: "label" }
const _hoisted_49 = ["value"]
const _hoisted_50 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.error != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", null, [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.warning(),
            class: "red"
          }, null, 8, ["icon"]),
          _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
        ]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('setup.contactSupport')), 1)
      ]))
    : (_ctx.device != null && _ctx.deviceLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass([{ 'is-active': _ctx.displaySetupLog }, "modal"])
          }, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("pre", {
                innerHTML: _ctx.device.setupLog
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("button", {
              "aria-label": "close",
              class: "modal-close is-large",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.displaySetupLog = false), ["prevent"]))
            })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass([{ 'is-active': _ctx.displayRebootConfirm || _ctx.displayRebootDone }, "modal"])
          }, [
            _createElementVNode("div", {
              class: "modal-background",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dismissReboot()))
            }),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t('setup.installComplete.title')), 1),
              (_ctx.displayRebootDone)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('setup.installComplete.rebooted')), 1),
                    _createElementVNode("button", {
                      class: "button is-primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dismissReboot()))
                    }, _toDisplayString(_ctx.$t('setup.close')), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('setup.installComplete.message')), 1),
                    _createElementVNode("button", {
                      class: "button is-primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmReboot()))
                    }, _toDisplayString(_ctx.$t('setup.reboot')), 1)
                  ], 64))
            ])
          ], 2),
          (!_ctx.hasRequestVersion())
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("h2", null, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.warning(),
                    class: "red"
                  }, null, 8, ["icon"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.updateRequired', { name: _ctx.device.name })), 1)
                ]),
                (_ctx.configuration)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.$t('setup.firmwareVersion', { version: _ctx.configuration.minVersionFirmware })), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('setup.updateFirmware', { name: _ctx.device.name })), 1)
              ]))
            : (!_ctx.deviceReady)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (!_ctx.device.hasServerLicense)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: _ctx.check(),
                          class: "red"
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.license.server.missing')), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: _ctx.check(),
                            class: "green"
                          }, null, 8, ["icon"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.license.server.found')), 1)
                        ]),
                        (!_ctx.device.hasDeviceLicense)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: _ctx.check(),
                                class: "red"
                              }, null, 8, ["icon"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.license.device.missing')), 1)
                            ]))
                          : (_ctx.device.hasLicenseToUpdate)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: _ctx.check(),
                                  class: "orange"
                                }, null, 8, ["icon"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.license.device.update')), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: _ctx.check(),
                                  class: "green"
                                }, null, 8, ["icon"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.license.device.found')), 1)
                              ]))
                      ])),
                  (_ctx.device.hasServerParameters)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        (_ctx.device.hasParametersToUpdate)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: _ctx.check(),
                                class: "orange"
                              }, null, 8, ["icon"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.parameters.update')), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: _ctx.check(),
                                class: "green"
                              }, null, 8, ["icon"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.parameters.found')), 1)
                            ]))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.configuration)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createVNode(_component_font_awesome_icon, {
                          class: _normalizeClass({ orange: !_ctx.configApplied, green: _ctx.configApplied }),
                          icon: _ctx.check()
                        }, null, 8, ["class", "icon"]),
                        _createTextVNode(" Configuration : "),
                        _createElementVNode("b", null, _toDisplayString(_ctx.configuration.name), 1),
                        _createTextVNode("  "),
                        (_ctx.device.setupLog)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: "#",
                              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.displaySetupLog = !_ctx.displaySetupLog), ["prevent"]))
                            }, "Voir les logs"))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "red",
                          icon: _ctx.check()
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.configNotFound')), 1)
                      ])),
                  (!_ctx.device.hasTimeUpToDate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: _ctx.check(),
                          class: "red"
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.date.needUpdate')), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: _ctx.check(),
                          class: "green"
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('setup.date.upToDate')), 1)
                      ])),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_25, [
                      _withDirectives(_createElementVNode("input", {
                        id: "override",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.override) = $event)),
                        disabled: _ctx.status != '',
                        type: "checkbox",
                        class: "switch is-rounded is-warning"
                      }, null, 8, _hoisted_26), [
                        [_vModelCheckbox, _ctx.override]
                      ]),
                      _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('setup.erase.base')), 1)
                    ]),
                    (_ctx.override)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _withDirectives(_createElementVNode("input", {
                            id: "overrideLarges",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.overrideLargesFiles) = $event)),
                            disabled: _ctx.status != '',
                            type: "checkbox",
                            class: "switch is-rounded is-danger"
                          }, null, 8, _hoisted_29), [
                            [_vModelCheckbox, _ctx.overrideLargesFiles]
                          ]),
                          _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('setup.erase.all')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      disabled: _ctx.status != '',
                      class: "button is-primary",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setupDevice()))
                    }, _toDisplayString(_ctx.$t('setup.install')), 9, _hoisted_31),
                    _createElementVNode("button", {
                      disabled: _ctx.status != '',
                      class: "button is-warning",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.rebootDevice()))
                    }, _toDisplayString(_ctx.$t('setup.reboot')), 9, _hoisted_32),
                    (_ctx.overrideLargesFiles && _ctx.status == '')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "notification is-warning mt-4",
                          innerHTML: _ctx.$t('setup.warning')
                        }, null, 8, _hoisted_33))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.status)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createElementVNode("h2", _hoisted_35, _toDisplayString(_ctx.status), 1),
                        _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t('setup.waiting')), 1),
                        (!_ctx.progress)
                          ? (_openBlock(), _createElementBlock("progress", _hoisted_37))
                          : (_openBlock(), _createElementBlock("progress", {
                              key: 1,
                              value: _ctx.progress,
                              class: "progress is-large is-primary",
                              max: "100"
                            }, null, 8, _hoisted_38))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t('headset.ready')), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('headset.thanks')), 1),
                  _createElementVNode("button", {
                    class: "button is-primary mt-4",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.resetDevice()))
                  }, _toDisplayString(_ctx.$t('headset.reset')), 1),
                  _createElementVNode("button", {
                    class: "button is-warning mt-4",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.rebootDevice()))
                  }, _toDisplayString(_ctx.$t('headset.reboot')), 1),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('headset.license.title')), 1),
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('headset.license.owner')) + ": ", 1),
                        _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.device.license.owner), 1),
                        _hoisted_43,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('headset.license.usage')) + ": ", 1),
                        _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.device.license.usage), 1),
                        _hoisted_45,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('headset.license.expires')) + ": ", 1),
                        (_ctx.device.license.expires)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.device.license.expires.toLocaleDateString()), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('headset.battery.title')), 1),
                      _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t('headset.battery.charge', {
                            technology: _ctx.device.battery.technology,
                            charged: _ctx.device.battery.percent
                        })), 1),
                      (_ctx.device.battery.percent)
                        ? (_openBlock(), _createElementBlock("progress", {
                            key: 0,
                            class: "mt-2 progress is-info is-large",
                            max: "100",
                            value: _ctx.device.battery.percent
                          }, null, 8, _hoisted_49))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('setup.loading')), 1)
        ]))
}